import { isNotWorkEmail } from "./form/utils";
import camelCase from "lodash/camelCase";

export const ADDRESS_FIELDS = ["street1", "street2", "city", "state", "country", "zipCode"];

export const getUserNameOrEmail = ({ firstName, lastName, email }) =>
  firstName || lastName ? `${firstName || ""} ${lastName || ""}`.trim() : email;

export const getBrandDomainForWorkEmails = (email: string): string => {
  if (isNotWorkEmail(email)) {
    return "";
  }

  return email.split("@")[1];
};

export const getUserInitials = (userObj: {
  firstName: string;
  lastName: string;
  email: string;
}) => {
  const { firstName, lastName, email } = userObj;
  if (firstName && lastName) {
    return firstName.substring(0, 1).toUpperCase() + lastName.substring(0, 1).toUpperCase();
  }
  return (email || "").substring(0, 2).toUpperCase();
};

export const getFormattedMaskedFields = (maskedFields: string[]): string[] => {
  const fields = (maskedFields || []).map((field) => camelCase(field));
  if (fields.includes("formatted")) {
    fields.push("homeAddress", "workAddress");
  }
  ADDRESS_FIELDS.forEach((field) => {
    if (fields.includes(field)) {
      fields.push(
        `home${field[0].toUpperCase()}${field.slice(1)}`,
        `work${field[0].toUpperCase()}${field.slice(1)}`,
      );
    }
  });
  return fields;
};

export const shouldMaskField = ({
  fieldName,
  maskedFields = [],
  permissions,
  value,
  hideFields = [],
}: {
  fieldName: string;
  maskedFields?: string[];
  permissions?: { can_see_pii_data?: boolean };
  value?: any;
  hideFields?: string[];
}): boolean => {
  const isFieldMasked = maskedFields.includes(fieldName);
  const canSeePiiData = permissions?.can_see_pii_data;
  const hasValue = value && value !== "";

  return isFieldMasked && (!canSeePiiData || hideFields.includes(fieldName)) && hasValue;
};
